import { gql } from '@apollo/client'

export const MUTATION_PROJECT_FILE_SET_ZONE = gql`
  mutation projectFileSetZone($input: ProjectFileSetZoneInput!) {
    projectFileSetZone(input: $input)
  }
`

export const MUTATION_PROJECT_FILE_UNSET_ZONE = gql`
  mutation projectFileUnsetZone($input: ProjectFileUnsetZoneInput!) {
    projectFileUnsetZone(input: $input)
  }
`
